import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalidadeGarantia } from 'src/app/model/modalidade_garantia.model';

@Component({
    selector: 'app-modal-validacao-inadimplencia',
    templateUrl: './modal-validacao-inadimplencia.component.html',
    styleUrls: ['./modal-validacao-inadimplencia.component.scss'],
    standalone: false
})
export class ModalValidacaoInadimplenciaComponent implements OnInit {

  @Input() modalidades: ModalidadeGarantia[];

  public modalidade: string;
  public mensagemAviso: string = "";

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit(): void {
  }

  public salvar() {
    if(this.modalidade != null) {
      this.activeModal.close({botao: 'salvar', valor: this.modalidade});
    }
    else if(this.modalidade == null) {
      this.mensagemAviso = "Escolha uma modalidade para salvar."
    }

    if(this.mensagemAviso) {
      setTimeout(() => {
        this.mensagemAviso = ""; 
      }, 5000);
    }
  }

  public cancelar() {
    this.activeModal.close({botao: 'cancelar', valor: null});
  }

  public fechar() {
    this.activeModal.close({botao: 'fechar', valor: null});
  }

}
